import axios from "axios"

export default {
    WorkingGroup:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/workinggroup/update' : '/api/workinggroup/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/workinggroup/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/workinggroup/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/workinggroup/list/select')
            return response
        },
        async ListByVisible(data){
            const response = await axios.get(`/api/workinggroup/list/select/${data}`)
            return response
        }
    },
    CarrierClassification:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/carrierclassification/update' : '/api/carrierclassification/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/carrierclassification/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/carrierclassification/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/carrierclassification/select/list')
            return response
        }
    },
    TrafficFine:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/trafficfine/update' : '/api/trafficfine/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/trafficfine/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/trafficfine/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/trafficfine/select/list')
            return response
        },
        async Upload(data) {
            const response = await axios.post("/api/trafficfine/uploadexcel", data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        async GetSampleExcel() {
            const response = await axios.get("/api/trafficfine/downloadsample", {
                responseType: "blob",
            });
            return response;
        },
    }
}
